import { Container, Grid } from "@mui/material"
import { makeStyles } from "makeStyles"
import Image from "next/image"

const useStyles = makeStyles()(() => ({
	root: {
		position: "relative",
		zIndex: 1,
		marginTop: 100,
		marginBottom: 50,
	},
	textBoxStyle: {
		background: "rgba(255, 255, 255, 0.1)",
		width: "100%",
		height: "100%",
		borderRadius: 5,
		padding: 15,
	},
	closureImage: {
		textAlign: "center",
	},
}))

const Closure = ({ closureContent, lockVariant }: Props) => {
	const { classes } = useStyles()

	return (
		<div className={classes.root}>
			<Container className={classes.textBoxStyle}>
				<Grid container spacing={3}>
					{lockVariant && (
						<Grid
							item
							xs={12}
							md={2}
							style={{ position: "relative", textAlign: "center" }}
						>
							<div className={classes.closureImage}>
								<Image
									alt="Verchluss"
									src={lockVariant}
									height={250}
									width={150}
									style={{
										maxWidth: "100%",
										objectFit: "contain",
									}}
								/>
							</div>
						</Grid>
					)}
					<Grid item xs={12} md={lockVariant ? 10 : 12}>
						<div
							dangerouslySetInnerHTML={{
								__html: closureContent,
							}}
							style={{ lineHeight: 1.4 }}
						/>
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

interface Props {
	closureContent: string
	lockVariant: string
}

export default Closure
